import React from "react";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import Landing from "../pages/Landing";
import SubscribedRoute from "./SubscribedRoute";
import Dashboard from "../pages/Dashboard";

export default function Home() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A1524]">
        <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
      </div>
    );
  }
  if (user === false) return <Landing />;
  return (
    <SubscribedRoute>
      <Dashboard />
    </SubscribedRoute>
  );
}
